/* src/app/components/common/folder-tree-view/folder-tree-view.component.scss */
.example-tree-progress-bar {
  margin-left: 30px;
}
/*# sourceMappingURL=folder-tree-view.component.css.map */
